// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contatti-js": () => import("./../../../src/pages/contatti.js" /* webpackChunkName: "component---src-pages-contatti-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pportfolio-js": () => import("./../../../src/pages/pportfolio.js" /* webpackChunkName: "component---src-pages-pportfolio-js" */),
  "component---src-pages-realizzazioni-js": () => import("./../../../src/pages/realizzazioni.js" /* webpackChunkName: "component---src-pages-realizzazioni-js" */),
  "component---src-pages-sviluppo-app-js": () => import("./../../../src/pages/sviluppo-app.js" /* webpackChunkName: "component---src-pages-sviluppo-app-js" */)
}

